import { inject, NgModule, PLATFORM_ID, provideAppInitializer } from '@angular/core';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { appReducer, CacheService, CoreModule, metaReducers, SettingsService } from '@gallaghercp/core-frontend';
import { ToastrModule } from 'ngx-toastr';
import { APP_CONFIG as LOCAL_APP_CONFIG } from './app.config';
import { StoreModule } from '@ngrx/store';
import { ClientRoutingModule } from './client/client-routing.module';
import { LayoutModule } from '@core-app/layout/layout.module';
import { X_SERVICE_ZONE } from '@core-app/tokens';
import { isPlatformServer } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { CampusService } from '@core-app/services/campus.service';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ClientRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    CoreModule,
    LayoutModule,
    StoreModule.forRoot({ app: appReducer }, { metaReducers }),
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initialiseAppConfig(inject(SettingsService), inject(PLATFORM_ID), inject(CampusService));
      return initializerFn();
    }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(withNoHttpTransferCache()),
    {
      provide: X_SERVICE_ZONE,
      useFactory: () => {
        const cacheService = inject(CacheService);
        const storedValue = cacheService.getFromStorage('x-service-zone');
        return storedValue ?? '1';
      },
    },
  ],
})
export class AppModule {}

export function initialiseAppConfig(
  settings: SettingsService,
  platformId: object,
  campus: CampusService,
): () => Promise<any> {
  const config = { ...LOCAL_APP_CONFIG };
  if (!isPlatformServer(platformId) && (config as any)['COMMIT_SHA']) {
    config.api = '/api/2.0';
  }
  return () => settings.init(LOCAL_APP_CONFIG).then(() => firstValueFrom(campus.retrieveEnabledCampuses()));
}
